import React, { useEffect, useState } from 'react';
import Close from "../../../assets/img/ic-close.svg";
import Add from "../../../assets/img/ic-add.svg";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import * as config from "../../../config";
import Util from "../../../utils/utils";
import $ from "jquery";

const AddToPlayList = ( { show, handleClose, PlayList, itemId } ) =>
{
	const [ state, setState ] = useState( {
		newPlayList : "",
		ingredients : [],
		ingedientsList : [],
		checkedList : [],
		playListAppendStatus : true,
		playList : PlayList,
		playListOutput : ""
	} );

	let listItems, errorOutput;
	const token = "Bearer " + Util.getSession( "token" );

	const onIngredientChange = ( e, id ) =>
	{

		let resultArray = [];

		if ( state.checkedList !== undefined && state.checkedList !== "" )
		{
			if ( e.target.checked )
			{
				resultArray = state.checkedList.filter( CheckedId =>
					CheckedId !== id
				);
				resultArray.push( id )
			}
			else
			{
				resultArray = state.checkedList.filter( CheckedId =>
					CheckedId !== id
				)
			}
		}

		setState( ( oldState ) => ( {
			...oldState, checkedList : resultArray
		} ) )
	};

	useEffect( () =>
		{
			if ( state.playList !== undefined && state.playListAppendStatus )
			{
				listItems = state.playList.map( ( item, index ) =>
					<div key={index} className="form-check w-100">
						<label className="form-check-label">
							<input name={"playlistid[" + item.id + "]"} onChange={( e ) => onIngredientChange( e, item.id )} type="checkbox" className="form-check-input playlist-id" value={item.id}/> {item.title}
						</label>
					</div>
				);

				setState( ( oldState ) => ( { ...oldState, playListOutput : listItems, playListAppendStatus : false } ) )
			}
		},
		[ state ]
	);


	const submitNewPlayList = async () =>
	{

		let bodyFormData = new FormData();

		bodyFormData.append( 'playlist_name', state.newPlayList );

		let response = await axios.post( config.api_url + "/playlist/create", bodyFormData, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/x-www-form-urlencoded',
				'Authorization' : token,
			}
		} );

		if ( response.data.status )
		{
			PlayList.splice( 0, 0, {
				status : true,
				id : response.data.play_list_id,
				title : response.data.title
			} );

			setState( ( oldState ) => ( {
				...oldState,
				newPlayList : "",
				error : [],
				playList : PlayList,
				playListAppendStatus : true
			} ) );

		}
		else
		{
			setState( ( oldState ) => ( { ...oldState, error : response.data.error } ) )
		}


	};

	const handleSubmit = async e =>
	{
		e.preventDefault();

		let bodyFormData = new FormData();


		// if ( state.checkedList !== undefined && state.checkedList !== "" && state.checkedList.length > 0 )
		// {
		// 	state.checkedList.map( ( item, key ) =>
		// 	{
		// 		bodyFormData.append( 'playlist_id[]', item );
		// 	} );
		// }

		$( '.playlist-id:checkbox:checked' ).each( function ()
		{
			bodyFormData.append( 'playlist_id[]', $(this).val() );
		} );

		bodyFormData.append( 'item_id', itemId );

		let response = await axios.post( config.api_url + "/playlist/add", bodyFormData, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/json',
				'Authorization' : token,
			}
		} );

		let responseData = response.data;

		if ( responseData.status )
		{
			setState( ( oldState ) => ( { ...oldState, newPlayList : "", error : [] } ) );
			handleClose()
		}
		else
		{
			setState( ( oldState ) => ( { ...oldState, error : responseData.error } ) )
		}

	};

	if ( state.error !== undefined && state.error !== "" )
	{
		errorOutput = state.error.map( ( item, index ) =>
			<span key={index} className="error badge badge-danger text-white text-left p-2 m-2">{item}</span>
		);
	}

	return (
		<Modal
			show={show}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			id="addToPlaylistModal"
			dialogClassName="add-to-playlist modal-dialog-centered m-auto">
			<form onSubmit={handleSubmit}>
				<Modal.Header>
					<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
						<img aria-hidden="true" src={Close} alt=""/>
					</button>
					<Modal.Title className="modal-title" id="addToPlaylistModalLabel">اضافه کردن به پلی لیست</Modal.Title>
				</Modal.Header>
				<Modal.Body className="add-to-playlist row m-0">
					<div className="btn-add-to-playlist d-flex">
						<img src={Add} alt="" onClick={submitNewPlayList}/>
						<input name="playlistid[]" className="btn-add-to-playlist" placeholder="پلی‌لیست جدید" value={state.newPlayList} onChange={( e ) => setState( ( oldState ) => ( {
							...oldState,
							newPlayList : e.target.value
						} ) )}/>
					</div>
					{state.playListOutput}
				</Modal.Body>
				<div className="pr-1 pl-1">
					{
						errorOutput
					}
				</div>
				<Modal.Footer className="justify-content-center">

					<Button type="submit">
						تایید
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default AddToPlayList;
